import React from "react";
import { AppBar, IconButton, Toolbar, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { dateConstants } from "constants/dateConstants";
import moment from "moment";
import { ArrowBack } from "@mui/icons-material";
import StatusChip from "components/statusChip";

const Header = () => {
  const location = useLocation();
  const pathName = location?.pathname;
  const response = location?.state?.response;
  const testTime = response?.testTime ?? response?.calibrationTime;
  const testTimeFmt = testTime
    ? moment(testTime).format(dateConstants.FULLDATETIME)
    : "-";
  const typeTitle = pathName?.includes("assembly")
    ? "Assembly Result"
    : pathName?.includes("calibration")
      ? "Calibration Control"
      : "";
  const title = `${testTimeFmt} - ${typeTitle}`;
  const status = response?.status ?? 0;

  return (
    <AppBar sx={styles.appBar}>
      <Toolbar sx={styles.toolbar}>
        <IconButton
          onClick={() => window.history.back()}
          sx={{ color: "black" }}
        >
          <ArrowBack />
        </IconButton>
        <Typography variant="h6" sx={{ color: "black" }}>
          {title}
        </Typography>
        <StatusChip status={status} />
      </Toolbar>
    </AppBar>
  );
};

export default React.memo(Header);

const styles = {
  toolbar: {
    minHeight: "72px !important",
    px: 3,
    display: "flex",
    alignItems: "center",
    gap: 2,
  },
  appBar: {
    boxShadow: "none",
    position: "fixed",
    zIndex: 1201,
    backgroundColor: "#FDFDFD",
    borderBottom: "1px solid #E9EAEB",
  },
};
